module.exports = __webpack_public_path__ + "media/images/icons/icon-4e6baf4012ab12a4c615f3ff10198425.png";